import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/photoPrintRequests',
        name: 'photoPrintRequests',
        meta: { sideMenuLabel: "Richieste foto" },
        component: () => import("./views/photoPrintRequestList.vue")
    },
    {
        path: '/photoPrintRequests/:identifier',
        name: 'photoPrintRequestDetail',
        meta: { },
        component: () => import("./views/photoPrintRequestDetail.vue")
    },
];

export default routes;